import type { Component, JSX } from "solid-js";
import { twMerge } from "tailwind-merge";

type ErrorMessageProps = {
	children: JSX.Element;
	class?: string;
};

export const ErrorMessage: Component<ErrorMessageProps> = (props) => {
	return (
		<div
			class={twMerge("caption-11-medium rounded-lg bg-[#EF4444] p-2 text-white", props.class)}
			role="alert"
		>
			{props.children}
		</div>
	);
};
